import {ADD_TO_CART_ACTION, ADD_TO_CART_ACTION_LOADER, CART_ACTION, CART_ACTION_LOADER,CLEAR_CART_MESSAGE} from "../type"

const initialState = {
  loader: false,
  items: [],
  cart_count: 0,
  cart: null,
    error: null,
  successMessage: null,
};

const CartReducer = (state = initialState, action) => {
  switch (action.type) {

    case CART_ACTION_LOADER:
    case ADD_TO_CART_ACTION_LOADER:
      return {
        ...state,
        loader: action.loader,
      };

    // Only overwrite cart fields the action actually carries, so error-only
    // actions (e.g. a failed quantity update) don't wipe items/cart_count/cart.
    case CART_ACTION:
    case ADD_TO_CART_ACTION:
      return {
        ...state,
        items: action.items !== undefined ? action.items : state.items,
        cart_count: action.cart_count !== undefined ? action.cart_count : state.cart_count,
        cart: action.cart || state.cart,
        error: action.error || null,
        successMessage: action.successMessage || null,
      };
case CLEAR_CART_MESSAGE:
      return {
        ...state,
        error: null,
        successMessage: null,
      };
    default:
      return state;
  }
}

export default CartReducer;
